import { useDispatch } from 'react-redux';

import { analyticsCardOnboardingInReviewClickDashboardFooter } from '@perpay-web/fintech/actions/analytics/perpayCreditCardOnboarding';
import CardUploadDocumentsSuccess from '@perpay-web/fintech/components/composite/CardUploadDocumentsSuccess/CardUploadDocumentsSuccess';
import { paths } from '@perpay-web/fintech/props/appPaths';

const CardUploadDocumentsSuccessContainer = ({ isPHO = false }) => {
    const dispatch = useDispatch();

    const onClickDashboard = () => {
        dispatch(analyticsCardOnboardingInReviewClickDashboardFooter());
    };
    const dashboardURL = isPHO
        ? `${paths.dashboard.path}?PHO_complete=true`
        : paths.dashboard.path;

    return (
        <CardUploadDocumentsSuccess
            onClickDashboard={onClickDashboard}
            dashboardURL={dashboardURL}
        />
    );
};

export default CardUploadDocumentsSuccessContainer;
